import create from "zustand";
import { persist } from "zustand/middleware";

type LogOutState = {
  isLoggingOut: boolean | null | undefined;
  setIsLoggingOut: (current: boolean | null | undefined) => void;
  _hasHydrated: boolean;
  setHydrated: () => void;
};

const useManageLogOutStore = create(
  persist<LogOutState>(
    (set) => ({
      isLoggingOut: null,
      setIsLoggingOut: (isLoggingOut) => set({ isLoggingOut }),
      _hasHydrated: false,
      setHydrated: () => set({ _hasHydrated: true }),
    }),
    {
      name: "manage-log-out",
      onRehydrateStorage: () => (state) => {
        // Called after rehydration; we set the flag
        state?.setHydrated();
      },
    }
  )
);

const useManageLogOut = () => {
  const { isLoggingOut, setIsLoggingOut, _hasHydrated } =
    useManageLogOutStore();

  return { setIsLoggingOut, isLoggingOut, hasHydrated: _hasHydrated };
};

export default useManageLogOut;
